import { enumeratedLifeCycle, readStates, updateStates } from '@/constants/lifecycle';
import { fieldLengths } from '@/constants/fields';

const vocabularyActions = {
  ADD_VOCABULARY_DATASET_LINK: 'ADD_VOCABULARY_DATASET_LINK',
  ADD_VOCABULARY_LINK: 'ADD_VOCABULARY_LINK',
  ADD_VOCABULARY_ROLE_ACTION: 'ADD_VOCABULARY_ROLE_ACTION',
  APPLY_VOCABULARIES: 'APPLY_VOCABULARIES',
  CLOSE_VOCABULARIES: 'CLOSE_VOCABULARIES',
  DELETE_VOCABULARY_DATASET_LINK: 'DELETE_VOCABULARY_DATASET_LINK',
  DELETE_VOCABULARY_LINK: 'DELETE_VOCABULARY_LINK',
  DELETE_VOCABULARY_ROLE_ACTION: 'DELETE_VOCABULARY_ROLE_ACTION',
  EDIT_VOCABULARY: 'EDIT_VOCABULARY',
  EDIT_VOCABULARY_ERROR: 'EDIT_VOCABULARY_ERROR',
  FETCH_VOCABULARIES: 'FETCH_VOCABULARIES',
  HIDE_SAVE_VOCABULARY: 'HIDE_SAVE_VOCABULARY',
  REFRESH_VOCABULARIES: 'REFRESH_VOCABULARIES',
  RESET_VOCABULARY: 'RESET_VOCABULARY',
  RESET_VOCABULARY_ERROR: 'RESET_VOCABULARY_ERROR',
  RESET_VOCABULARY_SUCCESS: 'RESET_VOCABULARY_SUCCESS',
  SHOW_SAVE_VOCABULARY: 'SHOW_SAVE_VOCABULARY',
  SHOW_VOCABULARIES: 'SHOW_VOCABULARIES',
  SHOW_VOCABULARIES_ERROR: 'SHOW_VOCABULARIES_ERROR',
  TOGGLE_VOCABULARIES_PRESENTATION: 'TOGGLE_VOCABULARIES_PRESENTATION',
  UPDATE_ACTIVE_VOCABULARY_PROPERTIES: 'UPDATE_ACTIVE_VOCABULARY_PROPERTIES',
  UPDATE_VOCABULARIES_FILTER: 'UPDATE_VOCABULARIES_FILTER',
  UPDATE_VOCABULARY: 'UPDATE_VOCABULARY',
  UPDATE_VOCABULARY_DATASET_LINK_PROPERTIES: 'UPDATE_VOCABULARY_DATASET_LINK_PROPERTIES',
  UPDATE_VOCABULARY_EMAIL_PROPERTIES: 'UPDATE_VOCABULARY_EMAIL_PROPERTIES',
  UPDATE_VOCABULARY_LINK_PROPERTIES: 'UPDATE_VOCABULARY_LINK_PROPERTIES',
  UPDATE_VOCABULARY_PROPERTIES: 'UPDATE_VOCABULARY_PROPERTIES',
  UPDATE_VOCABULARY_ROLE_ACTION_PROPERTIES: 'UPDATE_VOCABULARY_ROLE_ACTION_PROPERTIES',
};

export const vocabularyCodes = {
  COOKIE_PRIVACY_URL: 'cookie-privacy-link',
  DAR_CUSTOM_MESSAGE: 'data-access-request-message',
  DATASET_ACTIONS: 'dataset-actions',
  DRE_NAME: 'dre-name',
  EXTERNAL_URLS: 'external-links',
  EXTERNAL_URLS_NAME: 'external-links-name',
  FEEDBACK_URL: 'feedback-link',
  KB_URL: 'kb-link',
  KB_URL_TITLE: 'kb-link-title',
  LANDING_CUSTOM: 'landing-custom-content',
  LANDING_MESSAGE: 'landing-message',
  LANDING_PAGE_BANNER: 'landing-page-banner',
  LANDING_TITLE: 'landing-title',
  PARTNER_URL: 'partner-link',
  PARTNER_URL_TITLE: 'partner-link-title',
  PORTAL_URL: 'portal-link',
  REQUEST_ACCESS_EMAIL: 'request-access-email',
  REQUEST_APPROVED_EMAIL: 'request-approved-email',
  REQUEST_DENIED_EMAIL: 'request-denied-email',
  ROLE_ACTIONS: 'role-actions',
  SEARCH_URLS: 'search-links',
  SEARCH_URLS_TITLE: 'search-links-title',
  T_AND_C_URL: 't-and-c-link',
};

export const vocabularyGroupings = {
  CUSTOM_LINKS: 'custom-links',
  EMAIL_TEMPLATE: 'email-template',
  MARKDOWN: 'markdown',
  ROLE_ACTIONS: 'role-actions',
  URL: 'url',
  URLS: 'urls',
  TEXT: 'text',
};

export const vocabularyLists = ['all'];

export const vocabularyCategories = [...vocabularyLists, 'admin'];

export const vocabularyLifeCycle = [...enumeratedLifeCycle];

export const vocabularyStates = {
  ...readStates,
  ...updateStates,
};

export const vocabularyFieldLengths = {
  icon: fieldLengths.large,
  description: fieldLengths.large,
  value: fieldLengths.large,
  target: fieldLengths.small,
  email: fieldLengths.huge,
  emailSubject: fieldLengths.large,
  emailBody: fieldLengths.big,
  markdown: fieldLengths.huge,
  urls: fieldLengths.huge,
};

export default vocabularyActions;
